/** @format */

import { getTimestamp } from './getTimestamp';

export const getDateFromTimestamp = (timestamp, standardDate) => {
  const today = new Date(getTimestamp() * 1000 * -1);
  const date = new Date(timestamp * 1000 * -1);
  const todayObj = {
    hours: today.getHours(),
    minutes: today.getMinutes(),
    seconds: today.getSeconds(),
    day: today.getDate(),
    month: Number(today.getMonth()) + 1,
    year: today.getFullYear(),
  };

  const dateObj = {
    hours: date.getHours(),
    minutes:
      date.getMinutes().toString().length === 2
        ? date.getMinutes()
        : '0' + date.getMinutes().toString(),
    seconds: date.getSeconds(),
    day: date.getDate(),
    month: Number(date.getMonth()) + 1,
    year: date.getFullYear(),
  };

  if (
    todayObj.day === dateObj.day &&
    todayObj.month === dateObj.month &&
    todayObj.year === dateObj.year
  ) {
    if (standardDate) {
      return (
        dateObj.day +
        '/' +
        dateObj.month +
        '/' +
        dateObj.year +
        ' ' +
        dateObj.hours +
        ':' +
        dateObj.minutes
        // + ':'
        // + dateObj.seconds
      );
    } else {
      return (
        'Oggi ' + dateObj.hours + ':' + dateObj.minutes
        // + ':'
        // + dateObj.seconds
      );
    }
  } else if (
    todayObj.day - 1 === dateObj.day &&
    todayObj.month === dateObj.month &&
    todayObj.year === dateObj.year
  ) {
    if (standardDate) {
      return (
        dateObj.day +
        '/' +
        dateObj.month +
        '/' +
        dateObj.year +
        ' ' +
        dateObj.hours +
        ':' +
        dateObj.minutes
        // + ':'
        // + dateObj.seconds
      );
    } else {
      return (
        'Ieri ' + dateObj.hours + ':' + dateObj.minutes
        // + ':'
        // + dateObj.seconds
      );
    }
  } else if (
    todayObj.day + 1 === dateObj.day &&
    todayObj.month === dateObj.month &&
    todayObj.year === dateObj.year
  ) {
    if (standardDate) {
      return (
        dateObj.day +
        '/' +
        dateObj.month +
        '/' +
        dateObj.year +
        ' ' +
        dateObj.hours +
        ':' +
        dateObj.minutes
        // + ':'
        // + dateObj.seconds
      );
    } else {
      return (
        'Domani ' + dateObj.hours + ':' + dateObj.minutes
        // + ':'
        // + dateObj.seconds
      );
    }
  } else {
    return (
      dateObj.day +
      '/' +
      dateObj.month +
      '/' +
      dateObj.year +
      ' ' +
      dateObj.hours +
      ':' +
      dateObj.minutes
      // + ':'
      // + dateObj.seconds
    );
  }
};
